import React from "react";

const ShopDetail = () => {
  return (
                <div className="review" id="hidden__cont">
                  <p><i className="fa fa-check-square-o" aria-hidden="true"></i> <small> 100% ORIGINAL</small> <small className="bold-grey-text"> gurantee for all products at 
                      vaspacx.com
                  </small></p>
                  <p><i className="fa fa-shopping-bag" aria-hidden="true"></i> <small>Return within 30days</small><small className="bold-grey-text"> of receiving your order</small></p>
                </div>
  )
}

export default ShopDetail;